import { round } from './money';

export const fileToBase64 = async (file: File): Promise<string | undefined> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const bytesToMegabytes = (bytes: number) => {
  return round(bytes / 1024 / 1024, 2);
};

export const initials = (value: string): string[] =>
  value
    .trim()
    .split(' ')
    .map((word: string) => word.charAt(0));
